module.exports = __webpack_public_path__ + "static/img/logo_bj_HZ.200b559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/themes/logo_bj_HZ.jpg
// module id = v3XJ
// module chunks = 29